import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// let countdown = false;
class CookieConsent extends Component {
    constructor(props) {
        super(props);
        this.state = { show: false };
        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount() {
        const isShow = true; //localStorage.getItem(`CookieConsentClose`) ? moment().diff(moment(localStorage.getItem(`CookieConsentClose`)), 'd') >= 3 : 
        this.setState({ show: isShow });
        // if (isShow) {
        //     countdown = setTimeout(() => {
        //         this.setState({ show: false });
        //         localStorage.setItem('CookieConsentClose', moment().format("YYYY-MM-DD"))
        //     }, 7500);
        // }
    }

    // componentWillUnmount() {
    //     if (countdown) {
    //         clearTimeout(countdown);
    //         countdown = false;
    //     }
    // }

    handleClick() {
        this.setState({ show: false });
    }

    render() {
        if (!this.state.show) return null;
        return (
            <div className="position-fixed py-2 py-md-3" style={{ width: "100vw", bottom: 0, backgroundColor: `rgb(0, 0, 0, 0.7)`, position: 'relative' }}>
                <div className="container color-white" style={{ display: "flex", alignItems: "center", height: "100%" }}>
                    <div style={{ width: "70%" }}>เว็บไซต์นี้จัดเก็บข้อมูลเช่นคุกกี้เพื่อเปิดใช้งานการทำงานของไซต์ที่จำเป็นเช่นเดียวกับการตลาดการปรับเปลี่ยนในแบบของคุณและการวิเคราะห์ โดยสามารถอ่านรายละเอียดเพิ่มเติมได้ที่ <Link to={`/cookie-policy`} style={{ marginLeft: "2px", color: "#fff", textDecoration: "underline" }}>นโยบายคุ้กกี้</Link></div>
                    <button className="ml-5 btn btn-primary" style={{ width: "30%", height: 45 }} onClick={this.handleClick}>ยอมรับทั้งหมด</button>
                </div>
            </div>
        );
    }
}

export default CookieConsent